module.exports = __webpack_public_path__ + "img/ins.19aa740c.png";